import {TERRAIN_TOKENS} from "../../constants/tokens";

export const isHexTokenIsBlockerForMovement = (hexToken) => {
  return hexToken === TERRAIN_TOKENS.SEA || hexToken === TERRAIN_TOKENS.MOUNTAIN
}